var _rect, _rect2, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCircleBackArrow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 37,
    viewBox: "0 0 36 37",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    y: 0.339844,
    width: 36,
    height: 36,
    rx: 18,
    fill: "#F2F4F8"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 6,
    y: 6.33984,
    width: 24,
    height: 24,
    rx: 12,
    fill: "#F2F4F8"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M21.2071 11.6327C21.5976 12.0233 21.5976 12.6564 21.2071 13.047L15.9142 18.3398L21.2071 23.6327C21.5976 24.0233 21.5976 24.6564 21.2071 25.047C20.8166 25.4375 20.1834 25.4375 19.7929 25.047L13.7929 19.0469C13.6054 18.8594 13.5 18.6051 13.5 18.3398C13.5 18.0746 13.6054 17.8203 13.7929 17.6327L19.7929 11.6327C20.1834 11.2422 20.8166 11.2422 21.2071 11.6327Z",
    fill: "#171C1D"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCircleBackArrow);
export default __webpack_public_path__ + "static/media/CircleBackArrow.b6288676895dfa6ab8686e9712a3df8a.svg";
export { ForwardRef as ReactComponent };